import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {selectedPresentationSelector} from '../store/selectors/presentation.selectors';
import {defaultFonts} from '../utils/defaultFonts';
import {Option} from '../ui/components/common/Select';
import {usePresentationThemeDetailQuery} from './usePresentationThemeDetailQuery';

const useFontOptions = (): Option[] => {
    const presentation = useSelector(selectedPresentationSelector);
    const {data: theme} = usePresentationThemeDetailQuery(presentation.presentationThemeId);

    const allFonts = useMemo(
        () => (theme?.fonts || []).concat(theme?.defaultFonts ? theme.defaultFonts : defaultFonts),
        [theme?.fonts, theme?.defaultFonts]
    );

    return [
        ...(allFonts?.map((font) => ({
            label: font.name,
            value: font.url,
        })) || []),
    ];
};

export default useFontOptions;
